/**
 * @generated SignedSource<<d22b270479b37e0a12ed830b8eb33d81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductBaseTile_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetails_user" | "ProductInternalTools_user">;
  readonly " $fragmentType": "ProductBaseTile_user";
};
export type ProductBaseTile_user$key = {
  readonly " $data"?: ProductBaseTile_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductBaseTile_user",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductInternalTools_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "0b74d70458bbf0e5e68e56a5cbbd6de3";

export default node;
